import { Autocomplete, Chip, TextField } from "@mui/material";
import { OrgUser } from "../../../graphql/generated";
import userLabel from "../../../utils/labels/userLabel";

import { useTranslation } from "react-i18next";
import { capitalize } from "lodash";
import { testIds } from "./UserSelect.testIds";

export type UserSelectProps = {
  value: string[];
  onChange: (value: string[]) => void;
  users: Pick<OrgUser, "_id" | "email" | "firstName" | "lastName">[];
  "data-testid"?: string;
};

const UserSelect = ({
  value,
  onChange,
  users,
  "data-testid": dataTestId,
}: UserSelectProps) => {
  const { t } = useTranslation("users");
  return (
    <Autocomplete data-testid={dataTestId ?? testIds.userSelectUsersPicker}
      value={users.filter((user) => value.includes(user._id))}
      clearIcon={false}
      options={users}
      multiple
      renderTags={(value, props) =>
        value.map((user, index) => (
          <Chip label={userLabel(user)} {...props({ index })} />
        ))
      }
      renderInput={(params) => (
        <TextField
          label={capitalize(t("user.many", "Users"))}
          {...params}
          inputProps={{
            ...params.inputProps,
            "data-testid": dataTestId
              ? `${dataTestId}-input`
              : testIds.userSelectUsersSearch,
          }}
        />
      )}
      renderOption={(props, user) => (
        <li
          {...props}
          data-testid={`${dataTestId ?? testIds.userSelectUsersPicker}-option-${
            user._id
          }`}
        >
          {userLabel(user)}
        </li>
      )}
      getOptionLabel={(user) => userLabel(user)}
      onChange={(_, newValue) => {
        onChange(newValue.map((user) => user._id));
      }}
      id="user-select"
    />
  );
};

export default UserSelect;
